export function AutofillHoneypot() {
  return (
    <input
      type="email"
      name="username"
      autoComplete="username"
      tabIndex={-1}
      defaultValue=""
      aria-label="autofill-decoy"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '1px',
        height: '1px',
        border: 'none',
        background: 'transparent',
        color: 'transparent',
        caretColor: 'transparent',
        clipPath: 'inset(0 0 0 0)',
        opacity: 0.01,
      }}
    />
  );
}
